import { createSlice } from "@reduxjs/toolkit";
import { getVinErrorReports } from "./_vinErrorReportsAction";

interface VinErrorReport {
  _id: string;
  reportDate: string;
  vin: string;
  deviceImei: string;
  deviceName: string;
  reportedBy: string;
  imageUrl: string;
}

interface VinErrorReportsState {
  data: VinErrorReport[];
  totalRecord: number;
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
  isSuccess: boolean;
  responseCode: number | null;
  responseMessage: string;
  errorMessage: string;
  vinErrorReportSuccess: boolean;
  vinErrorReportMessage: string;
}

const initialState: VinErrorReportsState = {
  data: [],
  totalRecord: 0,
  currentPage: 1,
  totalPages: 1,
  isLoading: false,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  errorMessage: '',
  vinErrorReportSuccess: false,
  vinErrorReportMessage: ''
};

export const vinErrorReportsList = createSlice({
  name: "vinErrorReportsList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // Get VIN Error Reports
      .addCase(getVinErrorReports.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getVinErrorReports.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data.reports || [];
        state.totalRecord = payload.data.pagination.total || 0;
        state.currentPage = payload.data.pagination.page || 1;
        state.totalPages = payload.data.pagination.pages || 1;
        state.isSuccess = true;
        state.responseCode = payload.responseCode;
        state.responseMessage = payload.responseMessage || '';
      })
      .addCase(getVinErrorReports.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload as string;
      })
      
        },
});

export default vinErrorReportsList.reducer;
